import { useRef, useState } from 'react'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'
import { Box, Button, ButtonIcon, IconClose } from '@machobear/design-system'

import { Label } from '@/components/text'
import useOnClickOutside from '@/components/use-onclick-outside'

import { FilterWrapper } from '../elements'
import PriceSlider from '../price-slider'
import { handleDataLayerEvent } from '../utils'

const StyledFilterWrapper = styled(FilterWrapper)`
  width: 332px;
  margin-top: 8px;
  ${props => props.isExt && 'right: 0;'}
`

const PriceFilter = ({
  savedFilters,
  value,
  onChange,
  boundaries,
  clickOutsideCallback = () => {},
  close,
  isExt,
  companyId,
  extCompanyId
}) => {
  const { t } = useTranslation()
  const priceFilterRef = useRef()
  useOnClickOutside(priceFilterRef, e => clickOutsideCallback(e))
  const [values, setValues] = useState({ ...value })

  const handleChange = ([min_price, max_price]) => {
    handleDataLayerEvent('price')
    setValues({
      min_price,
      max_price
    })
  }

  const { min_price, max_price } = values

  return (
    <div ref={priceFilterRef}>
      <StyledFilterWrapper isExt={isExt}>
        <Box
          display="flex"
          flexDirection="column"
          padding="small"
          style={{ gap: '24px' }}
        >
          <Box display="flex" justifyContent="spaceBetween">
            <Label type="medium">
              {t('filters:b.listing_filter.edit.price.label', 'Price')}
            </Label>
            <ButtonIcon
              icon={<IconClose />}
              onClick={close}
              variant="transparent"
              tone="secondary"
            />
          </Box>
          <PriceSlider
            companyId={companyId}
            extCompanyId={extCompanyId}
            min_price={min_price}
            max_price={max_price}
            initial={value}
            filters={savedFilters}
            boundaries={boundaries}
            onChange={handleChange}
            condensed
          />
        </Box>
        <Box
          display="flex"
          justifyContent="spaceBetween"
          padding="small"
          background="neutralSoft"
          borderTop="borderNeutralLight"
        >
          <Box style={{ maxWidth: 'fit-content' }}>
            <Button
              variant="transparent"
              size="small"
              onClick={() => handleChange([null, null])}
            >
              {t('Clear')}
            </Button>
          </Box>
          <Box style={{ maxWidth: 'fit-content' }}>
            <Button
              onClick={() => onChange({ min_price, max_price })}
              size="small"
            >
              {t('common.save', 'Save')}
            </Button>
          </Box>
        </Box>
      </StyledFilterWrapper>
    </div>
  )
}

export default PriceFilter
